import useSearchParams from "@/hooks/useSearchParams";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { BRAND_FULL_SEARCH_PAGE, BRAND_SEARCH_PAGE } from "@/settings/constant";
import { useRouter } from "next/router";
import { useCallback, useEffect, useMemo, useState } from "react";
import { FilterKey } from "src/api/brand";
import { SearchQueryKey } from "src/api/search";
import { useBrandStore } from "../../BrandProvider";
export const routerOptions = {
    shallow: true,
    scroll: false
};
const ALL_SUBJECT = "all";
const useSearchBarHandler = (props)=>{
    const name = useBrandStore((state)=>state.brand.name);
    const { push , pathname , asPath  } = useRouter();
    const [currentSubject, setCurrentSubject] = useState(ALL_SUBJECT);
    const [keyword, setKeyword] = useState("");
    const searchParams = useSearchParams();
    const resultKeyword = useMemo(()=>searchParams.get("q"), [
        searchParams
    ]);
    const resultSubject = useMemo(()=>searchParams.get("subject"), [
        searchParams
    ]);
    const checkAsPath = useMemo(()=>{
        return (props === null || props === void 0 ? void 0 : props.useAsPath) ? asPath.split("?")[0] : pathname;
    }, [
        asPath,
        pathname
    ]);
    //path 변경의 핸들러
    const handleChangePath = useCallback((path)=>{
        const findPath = path ? path : (props === null || props === void 0 ? void 0 : props.useAsPath) ? checkAsPath : pathname;
        push({
            pathname: findPath,
            query: searchParams.toString()
        }, undefined, routerOptions);
    }, [
        push,
        searchParams
    ]);
    const handleDetailFilter = useCallback((filterName, filterItem)=>{
        //pagination 을 여기서 챙겨야 할지 살펴보자
        const isExist = searchParams.getAll(filterName);
        if (isExist) {
            searchParams.set(SearchQueryKey[filterName.toUpperCase()], filterItem);
        } else {
            searchParams.append(filterName, filterItem.toString());
        }
    }, [
        searchParams
    ]);
    const deleteKeyword = useCallback(()=>{
        searchParams.delete(SearchQueryKey.KEYWORD);
    }, [
        searchParams
    ]);
    const resetAllQuery = useCallback(()=>{
        if (searchParams.get("page")) searchParams.delete("page");
        //키워드 제외 모두 제거
        for(const key in FilterKey){
            searchParams.delete(FilterKey[key]);
        }
    }, [
        searchParams
    ]);
    // 과목 핸들러 체인지
    const handleMenuChangeHandler = useCallback((subject)=>{
        setCurrentSubject(subject);
        handleDetailFilter(SearchQueryKey.SUBJECT, subject);
    }, [
        handleDetailFilter
    ]);
    // 검색 버튼 클릭
    const handleSearchSubmitClick = useCallback(()=>{
        if (!keyword) return;
        //mx-192
        mixpanelEvent("[Brand] Searched from Search-bar", {
            "Search Category": currentSubject,
            "Search Term": keyword
        });
        setKeyword(keyword);
        // 과목과 키워드를 제외하고 다른 필터 query를 제거한다.
        if (currentSubject === ALL_SUBJECT) {
            resetAllQuery();
            handleDetailFilter("keyword", keyword);
            handleChangePath("".concat(BRAND_FULL_SEARCH_PAGE(name)));
        } else {
            handleDetailFilter("keyword", keyword);
            handleChangePath("".concat(BRAND_SEARCH_PAGE(name)));
        }
    }, [
        keyword,
        currentSubject
    ]);
    // query string에 subject가 있을 경우 해당 과목으로 설정
    useEffect(()=>{
        if (currentSubject === ALL_SUBJECT && searchParams.get(SearchQueryKey.SUBJECT)) {
            setCurrentSubject(()=>searchParams.get(SearchQueryKey.SUBJECT));
        }
    }, [
        searchParams
    ]);
    // query string에 keyword가 있을 경우 해당 키워드로 설정
    useEffect(()=>{
        if (!keyword && searchParams.get(SearchQueryKey.KEYWORD)) {
            setKeyword(searchParams.get(SearchQueryKey.KEYWORD));
        }
    }, [
        searchParams
    ]);
    return {
        currentSubject,
        keyword,
        setKeyword,
        setCurrentSubject,
        handleMenuChangeHandler,
        handleDetailFilter,
        handleChangePath,
        handleSearchSubmitClick,
        resultKeyword,
        resultSubject,
        deleteKeyword
    };
};
export default useSearchBarHandler;
